import type { MillsheetFieldsFragment } from '@mbfab/client-api'

//
// 「ミルシート明細一覧表」CSV ダウンロード。
// v1 apps/frontend/client/src/components/MillsheetPrintForm/CsvDownloadButton.tsx +
// MillsheetPrintForm.tsx の CSV 出力部分の移植。
// csv-stringify / file-saver は Node の Buffer を触るため、トップレベル import すると
// Storybook（ブラウザ）の静的 import が落ちる。クリック時の dynamic import に閉じ込める。
//

const CSV_HEADERS = [
  'メーカー',
  '商社',
  '需要家',
  '工区',
  '節',
  '発行日',
  '証明書番号',
  '注文番号',
  '内部番号',
  '鋼種',
  '規格',
  '長さ',
  '数量',
  '重量',
  '製鋼番号',
]

function convertCellValue(x: unknown): string {
  if (typeof x === 'string') {
    return x
  }
  if (typeof x === 'number') {
    return `${x}`
  }
  if (typeof x === 'boolean') {
    return x ? 'TRUE' : 'FALSE'
  }
  return ''
}

export function buildCsvRows(millsheets: readonly MillsheetFieldsFragment[]): string[][] {
  const rows = millsheets
    .flatMap((millsheet) => {
      const items = millsheet.millsheetItems.length === 0 ? [undefined] : millsheet.millsheetItems
      return items.map((item) => ({ millsheet, item }))
    })
    .map(({ millsheet, item }) => [
      millsheet.manufacturerName,
      millsheet.tradingCompany,
      millsheet.customer,
      item?.constructionArea,
      item?.member,
      millsheet.issuedDate,
      millsheet.no,
      millsheet.orderNumber,
      millsheet.innerNo,
      item?.steelType,
      item?.size,
      item?.length,
      item?.quantity,
      item?.weightBeforeProcessing,
      item?.heatNumber,
    ])

  return [CSV_HEADERS, ...rows.map((row) => row.map(convertCellValue))]
}

export async function downloadMillsheetCsv(millsheets: readonly MillsheetFieldsFragment[]): Promise<void> {
  const [{ stringify }, { saveAs }] = await Promise.all([import('csv-stringify/sync'), import('file-saver')])
  const csvData = buildCsvRows(millsheets)
  const csvString = stringify(csvData, { bom: true, escape_formulas: true })
  const blob = new Blob([csvString], { type: 'text/csv' })
  saveAs(blob, 'ミルシート明細一覧表.csv')
}
